export const MODES = {
  easy: { id: "easy", name: "Easy", numbers: 10, bombs: 2, lives: 3, memorize: 12, timerDefault: false, shuffle: "light", cols: 4, tagline: "Numbers 1–10 · steady layout", accent: "from-emerald-400 to-teal-500", badge: "bg-emerald-400/15 text-emerald-300 border-emerald-400/30" },
  medium: { id: "medium", name: "Medium", numbers: 12, bombs: 3, lives: 5, memorize: 10, timerDefault: true, shuffle: "full", cols: 5, tagline: "Numbers 1–12 · full shuffle", accent: "from-amber-400 to-orange-500", badge: "bg-amber-400/15 text-amber-300 border-amber-400/30" },
  hard: { id: "hard", name: "Hard", numbers: 15, bombs: 3, lives: 5, memorize: 7, timerDefault: true, shuffle: "full", cols: 6, tagline: "Numbers 1–15 · max chaos", accent: "from-rose-500 to-fuchsia-500", badge: "bg-rose-400/15 text-rose-300 border-rose-400/30" },
  custom: { id: "custom", name: "Custom", numbers: 12, bombs: 3, lives: 3, memorize: 8, timerDefault: true, shuffle: "full", cols: 5, tagline: "Your rules, your challenge", accent: "from-sky-400 to-violet-500", badge: "bg-sky-400/15 text-sky-300 border-sky-400/30" },
};

export const CUSTOM_LIMITS = {
  numbers: { min: 5, max: 25, label: "Numbers" },
  bombs: { min: 0, max: 6, label: "Star bombs" },
  lives: { min: 1, max: 10, label: "Hearts" },
  memorize: { min: 3, max: 20, label: "Timer (sec)" },
};

const colsFor = (total) => (total <= 12 ? 4 : total <= 20 ? 5 : total <= 24 ? 6 : 7);

const clamp = (v, { min, max }) => Math.min(max, Math.max(min, Math.round(Number(v)) || min));

export const buildCustomMode = (cfg) => {
  const c = Object.fromEntries(Object.entries(CUSTOM_LIMITS).map(([k, lim]) => [k, clamp(cfg[k], lim)]));
  return { ...MODES.custom, ...c, cols: colsFor(c.numbers + c.bombs) };
};

export const BOMB = "bomb";

const shuffleArr = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const buildLayout = (mode, prev) => {
  const values = [...Array.from({ length: mode.numbers }, (_, i) => i + 1), ...Array(mode.bombs).fill(BOMB)];
  if (mode.shuffle === "full" || !prev) return shuffleArr(values);
  const a = [...prev];
  for (let k = 0; k < 2; k++) {
    const i = Math.floor(Math.random() * a.length);
    const j = Math.floor(Math.random() * a.length);
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const TIMER_MULTIPLIER = 2;

export const scoreRound = (mode, secs, lives, timerOn, perfect) => {
  const base = mode.numbers * 10;
  const speed = Math.max(0, Math.round(mode.numbers * 20 - secs * 10));
  const hearts = lives * 25;
  const flawless = perfect ? mode.numbers * 15 : 0;
  const multiplier = timerOn ? TIMER_MULTIPLIER : 1;
  return { base, speed, hearts, flawless, multiplier, total: (base + speed + hearts + flawless) * multiplier };
};

export const bestKey = (id, timerOn) => `number_memory_best_points_${id}_${timerOn ? "timer" : "notimer"}`;
export const getBest = (id, timerOn) => Number(localStorage.getItem(bestKey(id, timerOn)) || 0);
